import ApiHelper from 'api-helper';
import { KarteDraft, KarteDraftForm, buildKarteDraftPayload } from '@common/helpers/karte-draft';

/**
 * カルテ入力中の一時保存 (No.173).
 *
 * Both endpoints answer with `{ draft: <object|null> }`. The key matters: a
 * bare null body arrives as `{}`, which is truthy and indistinguishable from a
 * stored draft — the same reason the 治療履歴 memo wraps its payload.
 */
/**
 * No.173 Q5 (案C): a karte another doctor saved after this draft. The draft is
 * kept either way — this only feeds the warning banner.
 */
export interface KarteDraftNewerKarte {
  doctor_name: string | null;
  created_at: string | null;
}

export interface KarteDraftResult {
  draft: KarteDraft | null;
  newerKarte: KarteDraftNewerKarte | null;
}

export async function fetchKarteDraftApi(
  patientId: number | null | undefined,
  userTreatmentId: number | null | undefined,
): Promise<KarteDraftResult> {
  const response = await ApiHelper.getApi('PatientV2Api')
    .getFeedbackDraft(patientId, { user_treatment_id: userTreatmentId });
  return {
    draft: (response && response.draft) || null,
    newerKarte: (response && response.newer_karte) || null,
  };
}

export async function saveKarteDraftApi(
  patientId: number | null | undefined,
  userTreatmentId: number | null | undefined,
  form: KarteDraftForm,
): Promise<KarteDraft | null> {
  const response = await ApiHelper.getApi('PatientV2Api')
    .saveFeedbackDraft(patientId, buildKarteDraftPayload(userTreatmentId, form));
  return (response && response.draft) || null;
}
